import React, { useState } from 'react';
import { Download, X } from 'lucide-react';
import { useInstallPrompt } from '../hooks/useInstallPrompt';

const DISMISS_KEY = 'choyero_install_dismissed';

export default function InstallBanner() {
  const { disponible, instalado, instalar } = useInstallPrompt();
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISS_KEY) === '1');

  if (!disponible || instalado || dismissed) return null;

  const cerrar = () => {
    localStorage.setItem(DISMISS_KEY, '1');
    setDismissed(true);
  };

  return (
    <div className="fixed top-0 inset-x-0 z-[1300] bg-gray-900 text-white px-4 py-2.5 flex items-center justify-center gap-3 text-sm shadow-lg">
      <span className="flex items-center gap-2">
        <span className="text-lg leading-none">📲</span>
        <span className="hidden sm:inline">Instala Choyero en tu celular para acceder más rápido</span>
        <span className="sm:hidden">Instala la app de Choyero</span>
      </span>
      <button
        onClick={instalar}
        className="flex items-center gap-1.5 bg-orange-500 hover:bg-orange-400 text-white font-semibold px-3 py-1 rounded-full transition"
      >
        <Download size={14} />
        Instalar
      </button>
      <button onClick={cerrar} className="text-gray-400 hover:text-white transition" title="Cerrar">
        <X size={16} />
      </button>
    </div>
  );
}
